import { DatePivotParams } from "../../entities/date_pivot_params";

export const paramsToTransformArgs = (
  params: DatePivotParams
): Record<
  string,
  string | string[] | [string, string, string[] | string][] | null
> => {
  return {
    filters: params.filters,
    post_filters: params.postFilters ?? [],
  };
};
